import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Stack
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 380,
  height: 206,
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  p: 4,
  outline: 'none',
  textAlign: 'center',
  padding: '30px 32px',
};

const WarningModal = ({ error, open, onClose }) => {


  const handleClose = () => onClose();

  return (
    <Modal
      open={open}
      onClose={() => { }}
      disableEscapeKeyDown
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      hideBackdrop
    >
      <Box sx={style}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'grey.700',
          }}
        >
          <CloseIcon />
        </IconButton>

        <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" sx={{ mb: 2 }}>
          {error ? (
            <WarningAmberRoundedIcon sx={{ color: '#FFBF00', fontSize: '20px', position: 'absolute', left: '33px' }} />
          ) : (
            <WarningAmberRoundedIcon sx={{ color: '#FFBF00', fontSize: '20px', position: 'absolute', left: '46px' }} />
          )}
          <Typography id="modal-title" variant="h6" sx={{ color: '#FFBF00' , fontWeight: 700, fontSize: '20px' }}>
            {error ? 'Something went wrong' : 'Warning!'}
          </Typography>
        </Stack>

        <Typography id="modal-description" sx={{ mb: 3, fontSize: '20px', lineHeight: '100%', marginTop: error ? '15px' : '22px', marginBottom: error ? '4px' : '15px' }}>
           You need to make the changes and then save. Please save before publishing the question.
        </Typography>

        <Button variant="text" sx={{ fontSize: '20px', color: 'black' }} onClick={handleClose}>
          CLOSE
        </Button>
      </Box>
    </Modal>
  );
};

export default WarningModal;